import { requester } from '../utils';

export const fetchAllComments = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllUserComments = (userId, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment/user/${userId}?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const replyToCustomerComment = (id, message) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment/reply`,
        method: 'POST',
        data: {
          id,
          message
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const updateCommentStatus = (id, status) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment/status`,
        method: 'PUT',
        data: {
          id,
          status
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const editResponse = (id, message) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment`,
        method: 'PUT',
        data: {
          id,
          message
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const changeCafeAccessStatusToResponse = (id, access) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment/allow-cafe-admin`,
        method: 'PUT',
        data: {
          id,
          isCafeAllowedToRespond: access
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};
